// @flow
import config from 'config/app.config';
import { Licenses } from 'types/common';

const getSpanishTaxAreas = () => [
  { value: '01', label: 'Andalucía' },
  { value: '02', label: 'Aragón' },
  { value: '03', label: 'Asturias' },
  { value: '04', label: 'Canarias' },
  { value: '05', label: 'Cantabria' },
  { value: '06', label: 'Castilla - La Mancha' },
  { value: '07', label: 'Castilla y León' },
  { value: '08', label: 'Cataluña' },
  { value: '09', label: 'Extremadura' },
  { value: '10', label: 'Galicia' },
  { value: '11', label: 'Illes Balears' },
  { value: '12', label: 'La Rioja' },
  { value: '13', label: 'Madrid' },
  { value: '14', label: 'Murcia' },
  { value: '15', label: 'Valencia' },
  { value: '16', label: 'Diputación Foral de Navarra' },
  { value: '17', label: 'Diputación Foral de Álava' },
  { value: '18', label: 'Diputación Foral de Guipúzcoa' },
  { value: '19', label: 'Diputación Foral de Vizcaya' },
  { value: '20', label: 'Ceuta' },
  { value: '21', label: 'Melilla' },
  //  { value: '22', label: 'Not resident' },
];

const getPortugalStates = () => [
  { value: '01', label: 'Aveiro' },
  { value: '02', label: 'Beja' },
  { value: '03', label: 'Braga' },
  { value: '04', label: 'Bragança' },
  { value: '05', label: 'Castelo Branco' },
  { value: '06', label: 'Coimbra' },
  { value: '07', label: 'Évora' },
  { value: '08', label: 'Faro' },
  { value: '09', label: 'Guarda' },
  { value: '10', label: 'Leiria' },
  { value: '11', label: 'Lisboa' },
  { value: '12', label: 'Portalegre' },
  { value: '13', label: 'Porto' },
  { value: '14', label: 'Santarém' },
  { value: '15', label: 'Setúbal' },
  { value: '16', label: 'Viana do Castelo' },
  { value: '17', label: 'Vila Real' },
  { value: '18', label: 'Viseu' },
  { value: '19', label: 'Madeira' },
  { value: '20', label: 'Açores' },
];

export const getInputStateOptions = () => {
  switch (config.license) {
    case Licenses.ES:
      return getSpanishTaxAreas();
    case Licenses.PT:
      return getPortugalStates();
    default:
      return [];
  }
};
